import { getDescription } from '../lib/getDescription';
import { stripQueryStringFromCdnUrl } from '../services/getUrlFromCdn';
import { PAGE_TYPES } from './page-types';

const Modules = {
  MEDIA: 'media',
  LOGO: 'logo',
  TITLE: 'productTitle',
  PRICE: 'price',
  SETUP_FEE: 'setupFee',
  BUSINESS_NAME: 'businessName',
  DESCRIPTION: 'description',
  DATE: 'date',
  LOCATION: 'location',
  MEETING_LINK: 'meetingLink',
};

export function getFormModules({ checkout, seller, isScreenshot, query = {}, isPreview }) {
  const modules = {};

  if (checkout.showLogo && !isScreenshot) {
    modules[Modules.LOGO] = true;
  }

  if (checkout.showProductName && (checkout.title || (checkout.allowDynamicTitle && query.title))) {
    modules[Modules.TITLE] = true;
  }

  if (seller.displayName && checkout.showStoreName && !isScreenshot) {
    modules[Modules.BUSINESS_NAME] = true;
  }

  const description = (() => {
    const description = getDescription({
      allowDynamicDescription: checkout.allowDynamicDescription,
      dynamicDescription: query.description,
      checkoutDescription: checkout.description,
      checkoutDescriptionHtml: checkout.descriptionHtml,
    });

    if (isPreview) {
      return stripQueryStringFromCdnUrl(description);
    }

    return description;
  })();

  if (description) {
    modules[Modules.DESCRIPTION] = true;
  }

  return modules;
}

export function getEventModules({ checkout, seller, isScreenshot, query = {}, isPreview }) {
  const modules = {};

  if (checkout.showLogo && !isScreenshot) {
    modules[Modules.LOGO] = true;
  }

  if (checkout.showProductName && (checkout.title || (checkout.allowDynamicTitle && query.title))) {
    modules[Modules.TITLE] = true;
  }

  if (seller.displayName && checkout.showStoreName && !isScreenshot) {
    modules[Modules.BUSINESS_NAME] = true;
  }

  const description = (() => {
    const description = getDescription({
      allowDynamicDescription: checkout.allowDynamicDescription,
      dynamicDescription: query.description,
      productDescription: checkout.eventDetails.description,
      productDescriptionHtml: checkout.eventDetails.descriptionHtml,
      checkoutDescription: checkout.description,
      checkoutDescriptionHtml: checkout.descriptionHtml,
    });

    if (isPreview) {
      return stripQueryStringFromCdnUrl(description);
    }

    return description;
  })();

  if (description) {
    modules[Modules.DESCRIPTION] = true;
  }

  if (checkout.showLocation && checkout?.eventDetails?.location) {
    modules[Modules.LOCATION] = true;
  }

  if (checkout.showMeetingLink) {
    modules[Modules.MEETING_LINK] = true;
  }

  if (checkout.showDate && checkout?.eventDetails?.startDate) {
    modules[Modules.DATE] = true;
  }

  return modules;
}

export function getProductModules({
  checkout,
  seller,
  isScreenshot,
  query = {},
  productPriceAmount,
  setupFeeAmount,
  discountedFromPrice,
  trialPeriodDays,
  startDate,
  isPreview,
}) {
  const modules = {};

  if (checkout.showLogo && !isScreenshot) {
    modules[Modules.LOGO] = true;
  }

  if (
    checkout.showProductName &&
    (checkout.product.title || (checkout.allowDynamicTitle && query.title))
  ) {
    modules[Modules.TITLE] = true;
  }

  if (
    checkout.showPrice &&
    (productPriceAmount || setupFeeAmount || discountedFromPrice || trialPeriodDays || startDate)
  ) {
    modules[Modules.PRICE] = true;
  }

  if (checkout.showSetupFee && setupFeeAmount) {
    modules[Modules.SETUP_FEE] = true;
  }

  if (seller.displayName && checkout.showStoreName && !isScreenshot) {
    modules[Modules.BUSINESS_NAME] = true;
  }

  const description = (() => {
    const description = getDescription({
      allowDynamicDescription: checkout.allowDynamicDescription,
      dynamicDescription: query.description,
      productDescription: checkout.product.description,
      productDescriptionHtml: checkout.product.descriptionHtml,
      checkoutDescription: checkout.description,
      checkoutDescriptionHtml: checkout.descriptionHtml,
    });

    if (isPreview) {
      return stripQueryStringFromCdnUrl(description);
    }

    return description;
  })();

  if (description) {
    modules[Modules.DESCRIPTION] = true;
  }

  return modules;
}

export function checkHasProductModules({
  checkout,
  seller,
  isScreenshot,
  query = {},
  productPriceAmount,
  setupFeeAmount,
  discountedFromPrice,
  trialPeriodDays,
  startDate,
}) {
  let modules = {};

  if (checkout.type === PAGE_TYPES.CHECKOUT) {
    modules = getProductModules({
      checkout,
      seller,
      isScreenshot,
      query,
      productPriceAmount,
      setupFeeAmount,
      discountedFromPrice,
      trialPeriodDays,
      startDate,
    });
  } else if (checkout.type === PAGE_TYPES.FORM) {
    modules = getFormModules({ checkout, seller });
  } else if (checkout.type === PAGE_TYPES.EVENT) {
    return false;
  }

  return Object.keys(modules).length > 0;
}

export function checkHasEventModules({ checkout, seller }) {
  if (checkout.type !== PAGE_TYPES.EVENT) {
    return false;
  }

  return Object.keys(getEventModules({ checkout, seller })).length > 0;
}

export default Modules;
